import { Box } from "@mui/material";
import TaskContent from "./components/taksContent";

const taskConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <TaskContent />
    </Box>
  );
};

export default taskConnectPage;
